<template>
  <el-carousel
      v-if="(isIndex&&isNeedLoading&&bannerList.length>1)"
      class="full-width"
      indicator-position="none"
      arrow="never"
      height="70px"
      :interval="3000"
  >
    <el-carousel-item v-for="(item) in bannerList" :key="item">
      <img
          class="indexBanner pointer full-width"
          :src="require('@/assets/images/index/'+item)"
          @click="handleLink(item)"
      >
    </el-carousel-item>
  </el-carousel>
  <img
      v-else-if="(isIndex&&isNeedLoading&&bannerList.length===1)"
      class="indexBanner pointer full-width one-banner"
      :src="require('@/assets/images/index/'+bannerList[0])"
      @click="handleLink(2)"
      @load="load"
      alt="indexBanner"
  />
</template>

<script>
import jumpPaymentCenter from "@/views/member/src/mixins/jumpPaymentCenter";
export default {
  name: "HeaderBanner",
  mixins: [jumpPaymentCenter],
  data() {
    return {
      isNeedLoading: false,
      timer: null,
      bannerList: [
        // "index_banner_2.png",
      ]
    }
  },
  computed: {
    isIndex() {
      return this.$route.path === "/";
    }
  },
  mounted() {
    if(this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.isNeedLoading = false;
    let flag = this.$route.path === "/";
    this.timer = setTimeout(()=>{
      this.isNeedLoading = flag
    },200)
  },
  methods: {
    handleLink(item) {
      const type = {
        1: ()=>location.href = ("https://www.wjx.cn/vm/ex7PnMt.aspx#"),
        2: ()=>this.jumpPaymentCenter(true),
        3: ()=>this.$router.push("/school-info/register"),
      }
      type[item]&&type[item]();
    },
    load() {
      if(this.isNeedLoading){
        let banner = document.querySelector(".indexBanner");
        banner.style.height = 70 + "px";
        banner.style.opacity = 1;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.indexBanner {
  height: 70px;
  transition: all 1s;
}
.indexBanner.one-banner {
  height: 0;
  opacity: 0;
  transition: height 1s;
}
</style>